module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Black Steel + Black Closed.b01eb7d1.png";